import { render, staticRenderFns } from "./configReposicionOptions.vue?vue&type=template&id=b8ba54b4"
import script from "./configReposicionOptions.vue?vue&type=script&lang=js"
export * from "./configReposicionOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports